import {Component, Input, OnInit} from '@angular/core';
import {WelfareProjectResult} from '../../class/result/welfare-project-result';
import {NbWindowRef} from '@nebular/theme';

@Component({
  selector: 'app-welfy-simple-project-result',
  templateUrl: './welfy-simple-project-result.component.html',
  styleUrls: ['./welfy-simple-project-result.component.css']
})
export class WelfySimpleProjectResultComponent implements OnInit {

  @Input()
  projectResult: WelfareProjectResult;

  showError = false;

  constructor(private ref: NbWindowRef) {
  }

  ngOnInit() {
    if (!this.projectResult) {
      this.showError = true;
    }
  }

  close() {
    this.ref.close();
  }

}
